module.exports = __webpack_public_path__ + "img/PCM_Booth_Diamond_people_version_A3_4x3.608bffa9.png";